import React, { useContext } from "react";
import styled from "styled-components";

import { EditContext } from "../EditContext";

export default function DeleteMessage(props) {
  const { toggleDelete, id } = props;
  const context = useContext(EditContext);

  return (
    <Container>
      <Message>Are you sure you want to delete this citation?</Message>
      <ButtonContainer>
        <CancelButton onClick={toggleDelete}>Cancel</CancelButton>
        <ConfirmButton onClick={() => context.deleteCitation(id)}>
          Delete
        </ConfirmButton>
      </ButtonContainer>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const Message = styled.p`
  font-family: ${({ theme }) => theme.textFont};
  font-size: ${({ theme }) => theme.text.sm};
`;

const Button = styled.button`
  font-family: ${({ theme }) => theme.textFont};
  font-size: ${({ theme }) => theme.text.xxs};
  color: #2e2e2e;
  letter-spacing: 0.02rem;
  font-weight: bold;
  border: none;
  border-radius: 2px;
  padding: 5px 18px 5px 18px;
  cursor: pointer;
  background-color: ${({ theme }) => theme.colors.offWhite};
  box-shadow: 1px 2px 3px 0px gray;

  &:hover {
    transform: translateY(-1px);
  }
`;

const CancelButton = styled(Button)`
  outline: 2px solid gray;
  margin-right: 20px;
  &:hover {
    outline: 2px solid ${({ theme }) => theme.colors.mainGold};
    background-color: ${({ theme }) => theme.colors.mainGold};
    color: white;
    transform: translateY(-1px);
  }
`;

const ConfirmButton = styled(Button)`
  outline: 2px solid red;
  margin-left: 20px;
  &:hover {
    background-color: red;
    color: white;
    transform: translateY(-1px);
  }
`;
